<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.permits.types.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddPermitTypeDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.permits.types.types_dialog.title_new') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/permitManagement/permitTypes"
          list-relative-path="permitTypes"
          list-item-component-name="PermitTypeListItem"
          list-item-prop-name="permitType"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/permitManagement/permitTypes"
        filter-relative-path="filters"
      />
    </div>

    <AddPermitTypeDialog
      :is-open="isAddPermitTypeDialogOpen"
      @close="isAddPermitTypeDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { permitTypesTableColumns } from '@/components/Administration/PermitManagement/PermitTypes/constants';
import AddPermitTypeDialog from '@/components/Administration/PermitManagement/PermitTypes/AddPermitTypeDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'PermitTypesV2',
  components: {
    AddPermitTypeDialog,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddPermitTypeDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.permitManagement.permitTypes.filters,
      isLoading: (state) => state.v2.admin.cms.permitManagement.permitTypes.isLoading,
    }),
    columns() {
      return permitTypesTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();

    this.$store.dispatch('v2/admin/cms/permitManagement/statuses/loadAllStatuses');
    this.$store.dispatch('v2/admin/cms/permitManagement/documents/loadAllDocuments');
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/permitManagement/permitTypes/load');
    },
  },
};
</script>
